/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as defs from './notification/defs'
export * as getPreferences from './notification/getPreferences'
export * as putPreferences from './notification/putPreferences'
